/**
* 基础菜单 商品管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>审核商家 - {{serv.name}}</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" class="user-search"></el-form>

    <el-form label-width="120px" :model="serv" ref="serv">
      <el-form-item label="商家名称" prop="name">
        <el-input size="small" disabled v-model="serv.name" auto-complete="off" placeholder="请输入商家名称"></el-input>
      </el-form-item>
      <el-form-item label="餐厅地址" prop="name">
        <el-input size="small" disabled v-model="serv.addr" auto-complete="off" placeholder="请输入餐厅地址"></el-input>
      </el-form-item>
      <el-form-item label="触发续储金额" prop="limitAmount">
        <el-input size="small" disabled v-model="serv.limitAmount" auto-complete="off" placeholder="请输入开户名"></el-input>
      </el-form-item>
      <el-form-item label="买单折扣" prop="name">
        <el-input size="small" disabled v-model="serv.rateSale" auto-complete="off" placeholder="请输入预存折扣"></el-input>
      </el-form-item>
      <el-form-item label="储值金额" prop="name">
        <el-input size="small" disabled v-model="serv.czAmount" auto-complete="off" placeholder="请输入储值金额"></el-input>
      </el-form-item>
      <el-form-item label="实际获得金额" prop="name">
        <el-input size="small" disabled v-model="serv.useAmount" auto-complete="off" placeholder="请输入实际获得金额"></el-input>
      </el-form-item>
      <el-form-item label="剩余额度" prop="name">
        <el-input size="small" disabled v-model="serv.curAmount" auto-complete="off" placeholder="请输入剩余额度"></el-input>
      </el-form-item>
      <el-form-item label="开户名" prop="bank_info1">
        <el-input size="small" disabled v-model="serv.bankInfo1[2]" auto-complete="off" placeholder="请输入开户名"></el-input>
      </el-form-item>
      <el-form-item label="开户行" prop="bank_info2">
        <el-input size="small" disabled v-model="serv.bankInfo1[0]" auto-complete="off" placeholder="请输入开户行">
        </el-input>
      </el-form-item>
      <el-form-item label="账号" prop="bank_info3">
        <el-input size="small" disabled v-model="serv.bankInfo1[1]" auto-complete="off" placeholder="请输入账号"></el-input>
      </el-form-item>

    </el-form>
    <div slot="footer" class="dialog-footer" style="display: flex; justify-content: center;">
      <el-button size="small" @click="$router.back(-1)">取消</el-button>
      <el-button size="small" type="primary" class="title" @click="editFormVisibleguanli =true">储值
      </el-button>
    </div>
    <el-dialog :title="储值" :visible.sync="editFormVisibleguanli" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="serv" ref="editForm">
        <el-form-item label="商家名称" prop="name">
          <el-input size="small" disabled v-model="serv.name" auto-complete="off" placeholder="请输入商家名称"></el-input>
        </el-form-item>
        <el-form-item label="商家地址" prop="name">
          <el-input size="small" disabled v-model="serv.addr" auto-complete="off" placeholder="请输入商家名称"></el-input>
        </el-form-item>
        <el-form-item label="储值城市" prop="name">
          <el-select disabled v-model="serv.cityId" filterable remote placeholder="请输入关键词" size="medium"
            :remote-method="getCityInfoList" @change="remoteMethod1">
            <el-option v-for="item in options" :key="item.cityId" :label="item.cityName" :value="item.cityId">
            </el-option>
          </el-select>
          <!--    <el-select disabled v-model="serv.cityId" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item label="出资公司" prop="corpId">
          <el-select disabled v-model="serv.corpId" placeholder="请选择" size="small">
            <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="储值金额" prop="name">
          <el-input size="small" disabled v-model="serv.czAmount" auto-complete="off" placeholder="请输入储值金额"></el-input>
        </el-form-item>
        <el-form-item label="实际获得金额" prop="name">
          <el-input size="small" disabled v-model="serv.useAmount" auto-complete="off" placeholder="请输入实际获得金额">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">储值
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    merchantDetail,
    getCityInfoList,
    merchantRecharge,
    investorCompany
  } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        editFormVisibleguanli: false,

        xg1: 0,
        editForm: {
          bank_info: '',
          branch_name: '',
          bank_id: '',
          token: localStorage.getItem('logintoken')
        },
        options: [],
        options1: [ ],
        title: '添加',
        province1: [],
        province_code: '',
        city1: [],
        city_code: '',
        bankCode: '',
        branchlist: [],
        bank_id: '',
        mchId: this.$route.query.id,
        serv: '',
        serv2: '',
        bankCardNo: ''
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
      // this.province()

      this.getCityInfoList()
      this.merchantDetail()
      this.investorCompany()
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      investorCompany() {
        let pro = {
          "userId": JSON.parse(localStorage.getItem('userdata')).muId,
        }
        investorCompany(pro).then(res => {
          this.options1 = res.data
        })
      },
      getCityInfoList(query) {
        this.options = []
        let pro = {
          "data": {
            "name": query,
          }
        }
        getCityInfoList(pro).then(res => {
          this.options = res.data
          this.merchantDetail()
        })
      },
      // 获取公司列表
      merchantDetail() {
        let pro = {
          "userId": JSON.parse(localStorage.getItem('userdata')).muId,
          "mchId": this.mchId
        }
        merchantDetail(pro).then(res => {
          if (res.data.bankInfo) {
            res.data.bankInfo1 = res.data.bankInfo.split('|')
          } else {
            res.data.bankInfo1 = ['', '', '', '']
          }
          this.serv = JSON.parse(JSON.stringify(res.data))
          this.serv2 = JSON.parse(JSON.stringify(res.data))
          this.serv.cityId = this.serv.cityId.toString()
          this.branch_name = res.data.bankInfo1[0]
          this.bankCardNo = res.data.bankInfo1[1]
          this.bank_id = res.data.bankInfo1[3]
        })
      },
      submitForm() {
        let pro = {
          "userId": JSON.parse(localStorage.getItem('userdata')).muId,
          "fundsId": this.mchId,
          "czAmount": this.serv2.czAmount
        }
        merchantRecharge(pro).then((res) => {
          if (res.code == 0) {
            this.$message({
              message: '储值成功',
              type: 'success'
            });
            this.$router.push({
              name: '商家储值'
            })
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
      }

    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/bus/stored.vue